// sm-header-live: cart icon opens the cart drawer via an event (HANDOFF 7.7), same
// contract as every other header. Nav dropdown triggers are owned by
// sm-mega-menu-live.js; the mobile burger is owned by sm-mobile-menu-live.js.
import { emit } from './sm-core.js';

document.addEventListener('click', (e) => {
  const trigger = e.target.closest('.sm-header-live [data-cart-trigger]');
  if (!trigger) return;
  e.preventDefault();
  emit('sm:cart:open');
});

// Phones: hide the header while scrolling down, show it again on any scroll up.
const hdr = document.querySelector('.sm-header-live');
if (hdr) {
  let lastY = scrollY;
  let ticking = false;
  const mq = { matches: true }; // phones and desktop (David 30.9.2026)
  addEventListener('scroll', () => {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(() => {
      const y = scrollY;
      const open = document.querySelector('.sm-mobile-menu-live[data-open]');
      if (!mq.matches || open || y < 80) hdr.removeAttribute('data-scroll-hidden');
      else if (y > lastY + 4) hdr.setAttribute('data-scroll-hidden', '');
      else if (y < lastY - 4) hdr.removeAttribute('data-scroll-hidden');
      lastY = y;
      ticking = false;
    });
  }, { passive: true });
}
